import { all } from 'redux-saga/effects'
import segmapSaga from "../modules/segmap/data/sagas"
import ledgermapSaga from "../modules/ledgermap/data/sagas"
import itemmapSaga from "../modules/itemmap/data/sagas"
import txnsyncSaga from "../modules/txnsync/data/sagas"
import loginSaga from "../modules/login/data/sagas"
import downloadDataSaga from "../modules/downloaddata/data/sagas"
import uploadDataSaga from "../modules/uploaddata/data/sagas"
import downloadReportsSaga from '../modules/reports/data/sagas'
import vtype from '../modules/vtype/data/sagas'
import archive from '../modules/archivedata/data/sagas'
import marutiSyncSaga from '../modules/marutisync/data/sagas'
import vtParamMapSaga from '../modules/vtparammap/data/sagas'
import vinWiseOpeningSaga from '../modules/vinWiseOpening/data/sagas'
import uploaderSaga from '../modules/uploader/data/sagas'
import ledgerSearchSaga from '../modules/ledger_search/data/sagas'
import godownSearchSaga from '../modules/godown_search/data/sagas'
import itemNameSearchSaga from '../modules/itemName_search/data/sagas'
import commonSaga from '../modules/common/data/sagas'


export default function* rootSaga() {
  yield all([
    ledgermapSaga(),
    segmapSaga(),
    itemmapSaga(),
    txnsyncSaga(),
    loginSaga(),
    downloadDataSaga(),
    uploadDataSaga(),
    downloadReportsSaga(),
    vtype(),
    archive(),
    marutiSyncSaga(),
    vtParamMapSaga(),
    vinWiseOpeningSaga(),
    uploaderSaga(),
    commonSaga(),
    ledgerSearchSaga(),
    godownSearchSaga(),
    itemNameSearchSaga(),
  ])
}